export function getLetterArray(letters)
{
    //choose triangular number sequence from amount of letters left
    let letterAmt = letters.length;
    //check chosen letter amount with possible stack sizes
    let stackSize = getClosestBaseNum(letterAmt, [2, 3, 4, 5]);
    let numSpots = getTriangleNum(stackSize);
    let arr = [];
    //this is wrong!!!! - SR 1/6/2022 I'm assuming that this is actually right, or it's so wrong it ends up working. who knows lol
    while (arr.length == 0 || numSpots > arr[0].length)
    {
        let rowNum = (arr.length == 0) ? 1 : arr[0].length + 1;
        let row = [];
        for (let r = 0; r < rowNum; r++)
        {
            row.push(letters.splice(Phaser.Math.Between(0, letters.length - 1), 1));
            numSpots--;
        }
        arr.unshift(row);
    }
    //return 2d stacking array
    return arr;
}

export function getTriangleNum(baseNum)
{
    return (baseNum * (baseNum + 1) / 2);
}

export function getClosestBaseNum(checkNum, baseNums)
{
    let diffs = [];
    let diffsToCheck = [];
    //need to return the base number index
    //match differences with between selected number length and triangle nums with base number index so index can be returned
    while (diffs.length < baseNums.length)
    {
        let baseTri = getTriangleNum(baseNums[diffs.length]);
        let d = Math.abs(checkNum - baseTri);
        diffs.push(d);
        //only check numbers lower than total array amount
        if (baseTri <= checkNum) diffsToCheck.push(d);
    }

    let closestDiff = Math.min(...diffsToCheck);
    //index of diff and correct baseNum will match
    return baseNums[diffs.indexOf(closestDiff)];
}